@if (cart$ | async; as cart) {
  @if (entries$ | async; as entries) {
    <div class="row">
      <div class="total-width">
        <app-uig-order-summary [cart]="cart" [shortVersion]="true"></app-uig-order-summary>
      </div>
    </div>
  }
}
